export default __webpack_public_path__ + "static/media/r4.f560d985.jpg";